import { createContext, useContext } from 'react';
import type { SlotContextSnapshot } from '../../stores/GlobalStateStore/types/slotContext';

// `undefined` (vs an empty record) lets compute-context skip the merge path
// entirely when no SlotOutletRunner ancestor exists.
export const SlotContextSnapshotsContext = createContext<
  Record<string, SlotContextSnapshot> | undefined
>(undefined);

export const useSlotContextSnapshots = () => {
  return useContext(SlotContextSnapshotsContext);
};
